import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { OGImageType } from '@/v2/types/meta'
import { PUBLIC_MAIN_ROUTES } from '../../routes'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/news-and-press.jpg'),
    alt: 'news and press page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'news and press page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'News <span>& Press</span>',
  description:
    'Welcome to the News & Press page of ShipAndStorage. Stay up-to-date with our latest announcements, service highlights, and company growth. Below are the most recent developments, along with the full range of services we offer to make your storage and shipping experience seamless.',
  image: {
    url: '/images/v2/pages/main-pages/news-and-press/hero-image.jpg',
    alt: 'News & Press'
  }
}

export const showcaseSectionContent = {
  subTitle: 'Latest News',
  title: 'ShipAndStorage Expands Nationwide with New Storage Locations',
  description:
    'ShipAndStorage is thrilled to announce the expansion of our storage network across the United States. With new locations and more storage units, we are now able to offer even more flexible and accessible storage solutions for residential and business needs.',
  image: {
    src: '/images/v2/pages/main-pages/news-and-press/shipandstorage-expands-nationwide-with-new-storage-locations.png',
    alt: 'ShipAndStorage Expands Nationwide with New Storage Locations'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Read More' }
}

export const paginationSectionContent = {
  title: 'Recent Articles',

  articles: [
    {
      id: 1,
      title: 'Corporate Business Program Launched to Streamline Operations',
      description:
        'We are excited to introduce our Corporate Business Program, offering customized storage and shipping solutions designed specifically for businesses. From tailored discounts to dedicated account management, this program helps businesses simplify logistics.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/corporate-business-program-launched-to-streamline-operations.png',
        alt: 'Corporate Business Program Launched to Streamline Operations'
      }
    },
    {
      id: 2,
      title: 'Introducing Residential Storage Services for Homeowners',
      description:
        'ShipAndStorage is proud to offer a new range of Residential Storage Services to meet the needs of homeowners. Whether you need temporary storage during a move or a long-term solution for your household items, we have flexible options for you.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/introducing-residential-storage-services-for-homeowners.png',
        alt: 'Introducing Residential Storage Services for Homeowners'
      }
    },
    {
      id: 3,
      title: 'Moving Box Storage Service Added for Your Convenience',
      description:
        'We are introducing our new Moving Box Storage service, offering you a secure and reliable place to store your moving boxes while you transition to a new home or office.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/moving-box-storage-service-added-for-your-convenience.png',
        alt: 'Moving Box Storage Service Added for Your Convenience'
      }
    },
    {
      id: 4,
      title: 'Luggage Storage Solutions for Travelers',
      description:
        'Our new Luggage Storage service provides a safe and convenient place for travelers to store their bags, whether for a few hours, days, or months.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/luggage-storage-solutions-for-travelers.png',
        alt: 'Luggage Storage Solutions for Travelers'
      }
    },
    {
      id: 5,
      title: 'Ship Items Directly to Storage with Our New Service',
      description:
        'ShipAndStorage makes it easier to store your items by introducing our Shipping to Storage service. Now, you can ship your belongings directly to our secure storage facilities for maximum convenience.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/ship-items-directly-to-storage-with-our-new-service.png',
        alt: 'Ship Items Directly to Storage with Our New Service'
      }
    },
    {
      id: 6,
      title: 'Drop-off Storage Service for Flexible Storage Options',
      description:
        'We’ve launched our new Drop-off Storage service, making it easier for you to store your belongings at any of our designated locations. Whether for a short-term or long-term need, we ensure your items are safe and secure.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/drop-off-storage-service-for-flexible-storage-options.png',
        alt: 'Drop-off Storage Service for Flexible Storage Options'
      }
    },
    {
      id: 7,
      title: 'Introducing Pick-up from Storage Service for Hassle-Free Retrieval',
      description:
        'ShipAndStorage now offers a Pick-up from Storage service, allowing customers to have their stored items picked up directly from their location. Convenient retrieval options ensure a seamless experience.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/introducing-pick-up-from-storage-service-for-hassle-free-retrieval.png',
        alt: 'Introducing Pick-up from Storage Service for Hassle-Free Retrieval'
      }
    },
    {
      id: 8,
      title: 'Comprehensive Business Storage Solutions Now Offered',
      description:
        'Our new range of Business Storage services helps businesses securely store documents, seasonal items, trade show materials, and more. With flexible storage solutions, your business is covered for all its storage needs.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/comprehensive-business-storage-solutions-now-offered.png',
        alt: 'Comprehensive Business Storage Solutions Now Offered'
      }
    },
    {
      id: 9,
      title: 'Document Storage and Archiving Service Launched',
      description:
        'ShipAndStorage is excited to offer Document Storage and Archiving services to businesses. Keep important documents organized, secure, and easily accessible whenever you need them.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/document-storage-and-archiving-service-launched.png',
        alt: 'Document Storage and Archiving Service Launched'
      }
    },
    {
      id: 10,
      title: 'Seasonal Item Storage Service for Businesses',
      description:
        'We are introducing our Seasonal Item Storage service, offering businesses a safe and organized place to store seasonal products, decorations, and other materials until needed.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/seasonal-item-storage-service-for-businesses.png',
        alt: 'Seasonal Item Storage Service for Businesses'
      }
    },
    {
      id: 11,
      title: 'Secure Storage for Product Samples',
      description:
        'ShipAndStorage is launching our Product Sample Storage service to keep your product samples safe, organized, and easily accessible for business needs, presentations, or distribution.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/secure-storage-for-product-samples.png',
        alt: 'Secure Storage for Product Samples'
      }
    },
    {
      id: 12,
      title: 'Promotional Material Storage Service Now Available',
      description:
        'We’re excited to introduce our Promotional Material Storage service, providing a secure place to store your marketing materials and access them easily whenever you need them for campaigns or events.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/promotional-material-storage-service-now-available.png',
        alt: 'Promotional Material Storage Service Now Available'
      }
    },
    {
      id: 13,
      title: 'Trade Show Storage Service for Event Materials',
      description:
        'ShipAndStorage now offers Trade Show Storage services, ensuring that your trade show displays, materials, and exhibits are securely stored and organized for easy access for your next event.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/trade-show-storage-service-for-event-materials.png',
        alt: 'Trade Show Storage Service for Event Materials'
      }
    },
    {
      id: 14,
      title: 'Office Equipment Storage Service Launched',
      description:
        'We are pleased to offer Office Equipment Storage for businesses that need a secure space to store office furniture, electronics, and supplies, ensuring everything stays protected and organized.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/office-equipment-storage-service-launched.png',
        alt: 'Office Equipment Storage Service Launched'
      }
    },
    {
      id: 15,
      title: 'Student-Friendly College Storage Solutions',
      description:
        'ShipAndStorage is offering tailored College Storage Solutions to help students store their dorm room items during breaks or off-seasons. Our flexible options make it easy for students to store their belongings during academic downtime.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/student-friendly-college-storage-solutions.png',
        alt: 'Student-Friendly College Storage Solutions'
      }
    },
    {
      id: 16,
      title: 'Dorm Room Storage Service for Students',
      description:
        'Our Dorm Room Storage service allows students to store their items securely while away from campus. Whether during the break or between semesters, we offer convenient and affordable storage options.',
      image: {
        src: '/images/v2/pages/main-pages/news-and-press/dorm-room-storage-service-for-students.png',
        alt: 'Dorm Room Storage Service for Students'
      }
    }
  ]
}
